import { Box, Button, FormField, Select, Image, Stack, Heading } from "grommet";
import React from "react";
import { Faction } from "./FactionsHome";
import axios from "./general/HttpClient";
import { BrowseThemes, Theme } from "./ThemeStore";

let eventSource;

const FactionViewOld = ({ faction, onUpdate }: { faction: Faction; onUpdate: Function }) => {
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [time, setTime] = React.useState(+new Date());
    const [showDetail, setShowDetail] = React.useState(false);

    const generateImage = (factionId: number) => {
        let now = new Date();
        const _messages = [] as string[];
        setLoading(true);
        setMessage("Starting generation...");
        if (!eventSource) {
            eventSource = new EventSource("/api/factions/generateImage?id=" + factionId, { withCredentials: true });

            eventSource.onmessage = (event) => {
                console.log(event.data);

                if (event.data.indexOf("faction") == 0) {
                    setMessage("Generating Faction Image");
                }

                if (event.data.indexOf("done") == 0) {
                    setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");

                    eventSource.close();
                    eventSource = null;
                    setTime(+new Date());
                    onUpdate();
                    setLoading(false);
                }
            };
        }
    };

    return (
        <Box style={{ width: "1280px" }} animation="slideDown">
            <Box key={faction.id} gap="small" style={{ width: "1280px", height: "512px", overflow: "hidden" }} margin="small" round={"40px"} border={{ size: "20px", color: "black" }} onClick={() => setShowDetail(!showDetail)}>
                <Stack anchor="center">
                    <Image src={"/api/images/" + faction.imageID + "&t=" + time} style={{ width: "1280px", height: "512px" }} alt=""></Image>
                    <Box background={{ color: "background", opacity: 0.5 }} pad="medium" fill>
                        <Heading>{faction.name}</Heading>
                    </Box>
                </Stack>
            </Box>
            {showDetail && (
                <Box animation="fadeIn" pad={"small"}>
                    <Box>{faction.name}</Box>
                    <Box>{faction.description}</Box>
                    <Box>{faction.strategy}</Box>
                    <Box>{faction.factionTheme}</Box>
                    <Box>{faction.visualDescription}</Box>
                    <Box direction="row" gap="small">
                        {!loading && <Button label="Generate Image" onClick={() => generateImage(faction.id)}></Button>}
                        {(loading || message) && <Box>{message}</Box>}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default FactionViewOld;
